/**
 * Created by Karol Kluska on 26.06.17.
 */

angular
  .module('app')
  .component('offersListItem', {
    templateUrl: 'app/components/offers/list/item/Item.html',
    controller: ListItem,
    bindings: {
      room: '<',
      personsCount: '<',
      rateplans: '<',
      onSave: '&'
    }
  });

/** @ngInject */
// eslint-disable-next-line
function ListItem(Currency, $translate, $uibModal, ENV, Params, ConfigBookingEngine) {
  var $this = this;
  $this.Currency = Currency;
  $this.$translate = $translate;
  $this.$uibModal = $uibModal;
  $this.ENV = ENV;
  $this.Params = Params;
  $this.ConfigBookingEngine = ConfigBookingEngine;
  $this.showRateplans = false;
}

ListItem.prototype = {
  $onInit: function () {
    var checkIn = this.Params.getCheckIn();
    var checkOut = this.Params.getCheckOut();
    this.showRateplans = this.Params.getRoomGroupId() !== null || this.Params.getRateplanId() !== null;
    this.lengthOfStay = moment(checkOut).diff(checkIn, 'days');
    this.attributes = this.getAttributes();
    this.showRateplanAvailability = this.ConfigBookingEngine.showRateplanAvailability();
  },

  handleSave: function (rateplan) {
    this.onSave({room: this.room, rateplan: rateplan});
  },

  getAvailability: function () {
    return this.room.availableUnits;
  },

  hasAvailability: function () {
    return this.getAvailability() > 0;
  },

  getRoomId: function () {
    return this.room.id;
  },

  getRoomName: function () {
    return this.room.name;
  },

  getRoomDescription: function () {
    return this.room.description;
  },

  getRoomSize: function () {
    return this.room.size;
  },

  getRoomMaxPersons: function () {
    return this.room.maxPersons;
  },

  getAttributes: function () {
    var result = [];
    if (this.getRoomSize() > 0) {
      result.push({icon: '<i class="fa fa-arrows-alt" aria-hidden="true"></i>', text: this.getRoomSize() + ' m<sup>2</sup>'});
    }
    if (this.getRoomMaxPersons() > 0) {
      result.push({icon: '<i class="fa fa-user" aria-hidden="true"></i>', text: 'max ' + this.getRoomMaxPersons()});
    }
    return result;
  },

  hasCleaningPrice: function () {
    return this.rateplans[0].prices.regularFee !== 0;
  },

  getAdditionalInfoPrice: function () {
    var cleaningPrice = this.rateplans[0].prices.regularFee;
    var formatCleaningPrice = this.Currency.getFormattedPrice(cleaningPrice);
    return this.$translate.instant('offers.item.CLEANING_PRICE', {
      price: formatCleaningPrice
    });
  },

  getThumbnailMini: function () {
    var images = this.room.images;

    if (images.length > 0) {
      return this.ENV.images.mini + this.room.images[0].src;
    }
    return '/assets/img/dummy.png';
  },

  getThumbnail: function () {
    var images = this.room.images;

    if (images.length > 0) {
      return this.ENV.images.middle + this.room.images[0].src;
    }
    return '/assets/img/dummy.png';
  },

  getImages: function () {
    return this.room.images;
  },

  getAvailableRateplans: function () {
    var result = [];
    for (var i = 0; i < this.rateplans.length; i++) {
      var rateplan = this.rateplans[i];
      var fulfillMinStay = true;
      var fulfillMaxStay = true;
      if (this.lengthOfStay && rateplan.minStay !== 0) {
        fulfillMinStay = this.lengthOfStay >= rateplan.minStay;
      }
      if (this.lengthOfStay && rateplan.maxStay !== 0) {
        fulfillMaxStay = this.lengthOfStay <= rateplan.maxStay;
      }
      var isAvailable = fulfillMinStay && fulfillMaxStay;
      if (isAvailable) {
        result.push(rateplan);
      }
    }
    return result;
  },

  hasAvailableRateplans: function () {
    return this.getAvailableRateplans().length > 0;
  },

  getCheapestRateplan: function () {
    var rateplans = this.hasAvailableRateplans() ? this.getAvailableRateplans() : this.rateplans;
    var cheapestRateplanIndex = 0;
    var cheapestRateplanPrice = rateplans[0].prices.price;
    for (var i = 0; i < rateplans.length; i++) {
      var rateplan = rateplans[i];
      var price = rateplan.prices.price;
      if (price < cheapestRateplanPrice) {
        cheapestRateplanPrice = price;
        cheapestRateplanIndex = i;
      }
    }
    return rateplans[cheapestRateplanIndex];
  },

  getCheapestRateplanPrice: function () {
    var cheapestRateplan = this.getCheapestRateplan();
    return this.Currency.getFormattedPrice(cheapestRateplan.prices.price);
  },

  getCheapestRateplanDiscountPrice: function () {
    var cheapestRateplan = this.getCheapestRateplan();
    if (this.hasCheapestRateplanDiscountPrice()) {
      return this.Currency.getFormattedPrice(cheapestRateplan.prices.discountPrice);
    }
    return this.getCheapestRateplanPrice();
  },

  hasCheapestRateplanDiscountPrice: function () {
    var cheapestRateplan = this.getCheapestRateplan();
    var prices = cheapestRateplan.prices;
    if (angular.isDefined(prices.discountPrice) && prices.discountPrice !== null) {
      return prices.discountPrice !== prices.price;
    }
    return false;
  },

  openRoomPresentation: function () {
    var $this = this;
    $this.$uibModal.open({
      component: 'modalPresentation',
      size: 'lg',
      resolve: {
        title: function () {
          return $this.getRoomName();
        },
        images: function () {
          return $this.getImages();
        },
        attributes: function () {
          return $this.attributes;
        },
        equipments: function () {
          return $this.room.equipments;
        },
        description: function () {
          return $this.getRoomDescription();
        }
      }
    }).result.then(function () {}, function () {});
  },

  openAvailability: function () {
    var $this = this;
    $this.$uibModal.open({
      component: 'modalRateplanAvailability',
      size: 'lg',
      resolve: {
        groupId: function () {
          return $this.getRoomId();
        },
        personsCount: function () {
          return $this.personsCount;
        }
      }
    }).result.then(function () {}, function () {});
  }
};
